import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Message } from 'semantic-ui-react';
import { OSMMap } from 'volto-venue';
import { RichText } from '@redturtle/iovisit-theme/components/Views';
import ContactInfo from '@redturtle/iovisit-theme/components/Blocks/Contacts/ContactsInfo';

const messages = defineMessages({
  default_title: {
    id: 'ContactsBlock_defaultTitle',
    defaultMessage: 'Contatti',
  },
  come_arrivare_title: {
    id: 'come_arrivare_title',
    defaultMessage: 'Come arrivare',
  },
});

const Body = ({ data, properties, isEditMode }) => {
  const intl = useIntl();
  const title = data?.title
    ? data.title
    : intl.formatMessage(messages.default_title);

  const content = properties;
  if (!content) return;

  const moreContacts = RichText({
    content: content.further_info,
  });

  const come_arrivare = RichText({
    content: content.come_arrivare,
  });

  const latitude = content?.geolocation?.latitude ?? 0;
  const longitude = content?.geolocation?.longitude ?? 0;
  const hasGeolocationData = !!(latitude || longitude);

  // check old contacts fields AND new object_list fields
  const hasTelephoneData =
    content.phone?.length > 0 ||
    !!content.fax ||
    content.phone_contacts?.length > 0;

  const hasLinkData =
    !!content.external_link ||
    !!content.email ||
    content.link_contacts?.length > 0;

  const hasData =
    content.street ||
    content.zip_code ||
    content.city ||
    content.country ||
    hasGeolocationData ||
    hasTelephoneData ||
    hasLinkData ||
    moreContacts ||
    come_arrivare;
  return !hasData ? (
    isEditMode ? (
      <Message size="mini">
        Geolocalizzazione: Nessun dato da mostrare.
        <br />
        Questo blocco non verrà mostrato in visualizzazione.
      </Message>
    ) : null
  ) : (
    <div className="block contacts">
      <div className="contacts-data-wrapper">
        <div className="contacts-data">
          <h2>{title}</h2>
          {(content.street ||
            content.zip_code ||
            content.city ||
            content.country) && (
            <p>
              {content.street && content.street + ' '}
              {content.street && content.zip_code && '- '}
              {content.zip_code && content.zip_code + ' '}
              {/* events have a select, others have a string */}
              {content.city && (content.city.title ?? content.city) + ' '}
              {content.country && <>({content.country})</>}
            </p>
          )}
          {(hasTelephoneData || hasLinkData) && (
            <p>
              <ContactInfo content={content} />
            </p>
          )}
          {moreContacts && moreContacts}
          {come_arrivare && (
            <div className="come_arrivare">
              <h2>{intl.formatMessage(messages.come_arrivare_title)}</h2>
              {come_arrivare}
            </div>
          )}
        </div>
        <div className="geolocation-map">
          {__CLIENT__ && hasGeolocationData && (
            <OSMMap
              center={[latitude, longitude]}
              markers={[{ ...content.geolocation, title: content.title }]}
              showTooltip
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Body;
